import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment/moment';

import { SantaModalComponent } from './modal/santa-modal/santa-modal.component';

@Component({
  selector: 'rk-santa',
  templateUrl: './santa.component.html',
  styleUrls: ['./santa.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SantaComponent implements OnInit {
  @Input()
  order: number;

  @HostBinding('class.hidden')
  hidden = false;

  constructor(private readonly dialog: MatDialog) {}

  ngOnInit() {
    const firstDay = moment('2022-12-01');
    const lastDay = moment('2022-12-25');
    const currentDayNumber = Number.parseInt(moment().format('D'), 10);
    this.hidden =
      moment().isBefore(firstDay) ||
      moment().isAfter(lastDay) ||
      currentDayNumber % 5 !== this.order;
  }

  santaModal() {
    this.dialog.open(SantaModalComponent);
  }
}
